<template>
    <svg
        width="660"
        height="466"
        viewBox="0 0 660 466"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M116 36C116 29.9249 120.925 25 127 25H533C539.075 25 544 29.9249 544 36V86C544 92.0751 539.075 97 533 97H127C120.925 97 116 92.0751 116 86V36ZM116 122C116 115.925 120.925 111 127 111H533C539.075 111 544 115.925 544 122V172C544 178.075 539.075 183 533 183H127C120.925 183 116 178.075 116 172V122ZM116 208C116 201.925 120.925 197 127 197H533C539.075 197 544 201.925 544 208V258C544 264.075 539.075 269 533 269H127C120.925 269 116 264.075 116 258V208ZM116 294C116 287.925 120.925 283 127 283H533C539.075 283 544 287.925 544 294V344C544 350.075 539.075 355 533 355H127C120.925 355 116 350.075 116 344V294ZM116 380C116 373.925 120.925 369 127 369H533C539.075 369 544 373.925 544 380V430C544 436.075 539.075 441 533 441H127C120.925 441 116 436.075 116 430V380Z"
            fill="var(--et-colors-background)"
            stroke="var(--et-colors-border)"
        />
        <path
            d="M131.5 49C131.5 44.8579 134.858 41.5 139 41.5H163C167.142 41.5 170.5 44.8579 170.5 49V73C170.5 77.1421 167.142 80.5 163 80.5H139C134.858 80.5 131.5 77.1421 131.5 73V49Z"
            fill="var(--et-colors-card-background)"
            stroke="var(--et-colors-border)"
        />
        <text
            opacity="0.8"
            fill="var(--et-colors-card-text)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="14"
            letter-spacing="0em"
        >
            <tspan x="181.21" y="77.8">a few seconds ago</tspan>
        </text>
        <path d="M313.5 62V82" stroke="#D0D5DD" />
        <text
            opacity="0.8"
            fill="var(--et-colors-card-text)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="14"
            letter-spacing="0em"
        >
            <tspan x="323.874" y="77.8">verified by</tspan>
        </text>
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M434.451 73.2671C434.451 70.5328 433.127 68.3752 430.596 68.3752C428.054 68.3752 426.516 70.5328 426.516 73.2457C426.516 76.4607 428.331 78.0841 430.937 78.0841C432.208 78.0841 433.17 77.7958 433.896 77.3899V75.2537C433.17 75.6169 432.337 75.8412 431.279 75.8412C430.243 75.8412 429.325 75.478 429.207 74.2177H434.43C434.43 74.0788 434.451 73.5234 434.451 73.2671ZM429.175 72.2524C429.175 71.0455 429.912 70.5435 430.585 70.5435C431.236 70.5435 431.931 71.0455 431.931 72.2524H429.175Z"
            fill="#635BFF"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M422.393 68.3752C421.346 68.3752 420.673 68.8666 420.299 69.2084L420.16 68.5461H417.81V81L420.481 80.434L420.491 77.4112C420.876 77.689 421.442 78.0841 422.382 78.0841C424.294 78.0841 426.035 76.5461 426.035 73.1603C426.024 70.0628 424.262 68.3752 422.393 68.3752ZM421.752 75.7344C421.122 75.7344 420.748 75.5101 420.491 75.2324L420.481 71.2698C420.758 70.96 421.143 70.7464 421.752 70.7464C422.724 70.7464 423.397 71.8359 423.397 73.2351C423.397 74.6663 422.734 75.7344 421.752 75.7344Z"
            fill="#635BFF"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M414.136 67.745L416.817 67.1682V65L414.136 65.5661V67.745Z"
            fill="#635BFF"
        />
        <path d="M416.817 68.5566H414.136V77.9024H416.817V68.5566Z" fill="#635BFF" />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M411.263 69.3472L411.092 68.5568H408.785V77.9026H411.455V71.5688C412.085 70.7464 413.154 70.8959 413.485 71.0134V68.5568C413.143 68.4286 411.893 68.1937 411.263 69.3472Z"
            fill="#635BFF"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M405.923 66.2389L403.316 66.7943L403.306 75.3497C403.306 76.9305 404.491 78.0947 406.072 78.0947C406.948 78.0947 407.589 77.9345 407.941 77.7422V75.574C407.599 75.7129 405.912 76.2042 405.912 74.6234V70.8317H407.941V68.5566H405.912L405.923 66.2389Z"
            fill="#635BFF"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M398.702 71.2698C398.702 70.8532 399.044 70.693 399.61 70.693C400.422 70.693 401.447 70.9387 402.259 71.3766V68.8666C401.373 68.5141 400.497 68.3752 399.61 68.3752C397.442 68.3752 396 69.5074 396 71.3979C396 74.3459 400.059 73.8759 400.059 75.1469C400.059 75.6383 399.632 75.7985 399.033 75.7985C398.147 75.7985 397.015 75.4353 396.117 74.944V77.486C397.111 77.9132 398.115 78.0949 399.033 78.0949C401.255 78.0949 402.782 76.9947 402.782 75.0828C402.772 71.8999 398.702 72.466 398.702 71.2698Z"
            fill="#635BFF"
        />
        <path
            d="M131.5 135C131.5 130.858 134.858 127.5 139 127.5H163C167.142 127.5 170.5 130.858 170.5 135V159C170.5 163.142 167.142 166.5 163 166.5H139C134.858 166.5 131.5 163.142 131.5 159V135Z"
            fill="var(--et-colors-card-background)"
            stroke="var(--et-colors-border)"
        />
        <text
            opacity="0.8"
            fill="var(--et-colors-card-text)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="14"
            letter-spacing="0em"
        >
            <tspan x="181.224" y="163.8">1 minute go ago</tspan>
        </text>
        <path d="M292.5 148V168" stroke="#D0D5DD" />
        <text
            opacity="0.8"
            fill="var(--et-colors-card-text)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="14"
            letter-spacing="0em"
        >
            <tspan x="302.874" y="163.8">verified by</tspan>
        </text>
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M413.451 159.267C413.451 156.533 412.127 154.375 409.596 154.375C407.054 154.375 405.516 156.533 405.516 159.246C405.516 162.461 407.331 164.084 409.937 164.084C411.208 164.084 412.17 163.796 412.896 163.39V161.254C412.17 161.617 411.337 161.841 410.279 161.841C409.243 161.841 408.325 161.478 408.207 160.218H413.43C413.43 160.079 413.451 159.523 413.451 159.267ZM408.175 158.252C408.175 157.045 408.912 156.543 409.585 156.543C410.236 156.543 410.931 157.045 410.931 158.252H408.175Z"
            fill="#635BFF"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M401.393 154.375C400.346 154.375 399.673 154.867 399.299 155.208L399.16 154.546H396.81V167L399.481 166.434L399.491 163.411C399.876 163.689 400.442 164.084 401.382 164.084C403.294 164.084 405.035 162.546 405.035 159.16C405.024 156.063 403.262 154.375 401.393 154.375ZM400.752 161.734C400.122 161.734 399.748 161.51 399.491 161.232L399.481 157.27C399.758 156.96 400.143 156.746 400.752 156.746C401.724 156.746 402.397 157.836 402.397 159.235C402.397 160.666 401.734 161.734 400.752 161.734Z"
            fill="#635BFF"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M393.136 153.745L395.817 153.168V151L393.136 151.566V153.745Z"
            fill="#635BFF"
        />
        <path d="M395.817 154.557H393.136V163.902H395.817V154.557Z" fill="#635BFF" />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M390.263 155.347L390.092 154.557H387.785V163.903H390.455V157.569C391.085 156.746 392.154 156.896 392.485 157.013V154.557C392.143 154.429 390.893 154.194 390.263 155.347Z"
            fill="#635BFF"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M384.923 152.239L382.316 152.794L382.306 161.35C382.306 162.931 383.491 164.095 385.072 164.095C385.948 164.095 386.589 163.935 386.941 163.742V161.574C386.599 161.713 384.912 162.204 384.912 160.623V156.832H386.941V154.557H384.912L384.923 152.239Z"
            fill="#635BFF"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M377.702 157.27C377.702 156.853 378.044 156.693 378.61 156.693C379.422 156.693 380.447 156.939 381.259 157.377V154.867C380.373 154.514 379.497 154.375 378.61 154.375C376.442 154.375 375 155.507 375 157.398C375 160.346 379.059 159.876 379.059 161.147C379.059 161.638 378.632 161.798 378.033 161.798C377.147 161.798 376.015 161.435 375.117 160.944V163.486C376.111 163.913 377.115 164.095 378.033 164.095C380.255 164.095 381.782 162.995 381.782 161.083C381.772 157.9 377.702 158.466 377.702 157.27Z"
            fill="#635BFF"
        />
        <path
            d="M131.5 221C131.5 216.858 134.858 213.5 139 213.5H163C167.142 213.5 170.5 216.858 170.5 221V245C170.5 249.142 167.142 252.5 163 252.5H139C134.858 252.5 131.5 249.142 131.5 245V221Z"
            fill="var(--et-colors-card-background)"
            stroke="var(--et-colors-border)"
        />
        <text
            opacity="0.8"
            fill="var(--et-colors-card-text)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="14"
            letter-spacing="0em"
        >
            <tspan x="181.944" y="249.8">3 hours ago</tspan>
        </text>
        <path d="M268.5 234V254" stroke="#D0D5DD" />
        <text
            opacity="0.8"
            fill="var(--et-colors-card-text)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="14"
            letter-spacing="0em"
        >
            <tspan x="278.874" y="249.8">verified by</tspan>
        </text>
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M389.451 245.267C389.451 242.533 388.127 240.375 385.596 240.375C383.054 240.375 381.516 242.533 381.516 245.246C381.516 248.461 383.331 250.084 385.937 250.084C387.208 250.084 388.17 249.796 388.896 249.39V247.254C388.17 247.617 387.337 247.841 386.279 247.841C385.243 247.841 384.325 247.478 384.207 246.218H389.43C389.43 246.079 389.451 245.523 389.451 245.267ZM384.175 244.252C384.175 243.045 384.912 242.543 385.585 242.543C386.236 242.543 386.931 243.045 386.931 244.252H384.175Z"
            fill="#635BFF"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M377.393 240.375C376.346 240.375 375.673 240.867 375.299 241.208L375.16 240.546H372.81V253L375.481 252.434L375.491 249.411C375.876 249.689 376.442 250.084 377.382 250.084C379.294 250.084 381.035 248.546 381.035 245.16C381.024 242.063 379.262 240.375 377.393 240.375ZM376.752 247.734C376.122 247.734 375.748 247.51 375.491 247.232L375.481 243.27C375.758 242.96 376.143 242.746 376.752 242.746C377.724 242.746 378.397 243.836 378.397 245.235C378.397 246.666 377.734 247.734 376.752 247.734Z"
            fill="#635BFF"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M369.136 239.745L371.817 239.168V237L369.136 237.566V239.745Z"
            fill="#635BFF"
        />
        <path d="M371.817 240.557H369.136V249.902H371.817V240.557Z" fill="#635BFF" />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M366.263 241.347L366.092 240.557H363.785V249.903H366.455V243.569C367.085 242.746 368.154 242.896 368.485 243.013V240.557C368.143 240.429 366.893 240.194 366.263 241.347Z"
            fill="#635BFF"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M360.923 238.239L358.316 238.794L358.306 247.35C358.306 248.931 359.491 250.095 361.072 250.095C361.948 250.095 362.589 249.935 362.941 249.742V247.574C362.599 247.713 360.912 248.204 360.912 246.623V242.832H362.941V240.557H360.912L360.923 238.239Z"
            fill="#635BFF"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M353.702 243.27C353.702 242.853 354.044 242.693 354.61 242.693C355.422 242.693 356.447 242.939 357.259 243.377V240.867C356.373 240.514 355.497 240.375 354.61 240.375C352.442 240.375 351 241.507 351 243.398C351 246.346 355.059 245.876 355.059 247.147C355.059 247.638 354.632 247.798 354.033 247.798C353.147 247.798 352.015 247.435 351.117 246.944V249.486C352.111 249.913 353.115 250.095 354.033 250.095C356.255 250.095 357.782 248.995 357.782 247.083C357.772 243.9 353.702 244.466 353.702 243.27Z"
            fill="#635BFF"
        />
        <path
            d="M131.5 307C131.5 302.858 134.858 299.5 139 299.5H163C167.142 299.5 170.5 302.858 170.5 307V331C170.5 335.142 167.142 338.5 163 338.5H139C134.858 338.5 131.5 335.142 131.5 331V307Z"
            fill="var(--et-colors-card-background)"
            stroke="var(--et-colors-border)"
        />
        <text
            opacity="0.8"
            fill="var(--et-colors-card-text)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="14"
            letter-spacing="0em"
        >
            <tspan x="181.792" y="335.8">6 hours ago</tspan>
        </text>
        <path d="M268.5 320V340" stroke="#D0D5DD" />
        <text
            opacity="0.8"
            fill="var(--et-colors-card-text)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="14"
            letter-spacing="0em"
        >
            <tspan x="278.874" y="335.8">verified by</tspan>
        </text>
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M389.451 331.267C389.451 328.533 388.127 326.375 385.596 326.375C383.054 326.375 381.516 328.533 381.516 331.246C381.516 334.461 383.331 336.084 385.937 336.084C387.208 336.084 388.17 335.796 388.896 335.39V333.254C388.17 333.617 387.337 333.841 386.279 333.841C385.243 333.841 384.325 333.478 384.207 332.218H389.43C389.43 332.079 389.451 331.523 389.451 331.267ZM384.175 330.252C384.175 329.045 384.912 328.543 385.585 328.543C386.236 328.543 386.931 329.045 386.931 330.252H384.175Z"
            fill="#635BFF"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M377.393 326.375C376.346 326.375 375.673 326.867 375.299 327.208L375.16 326.546H372.81V339L375.481 338.434L375.491 335.411C375.876 335.689 376.442 336.084 377.382 336.084C379.294 336.084 381.035 334.546 381.035 331.16C381.024 328.063 379.262 326.375 377.393 326.375ZM376.752 333.734C376.122 333.734 375.748 333.51 375.491 333.232L375.481 329.27C375.758 328.96 376.143 328.746 376.752 328.746C377.724 328.746 378.397 329.836 378.397 331.235C378.397 332.666 377.734 333.734 376.752 333.734Z"
            fill="#635BFF"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M369.136 325.745L371.817 325.168V323L369.136 323.566V325.745Z"
            fill="#635BFF"
        />
        <path d="M371.817 326.557H369.136V335.902H371.817V326.557Z" fill="#635BFF" />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M366.263 327.347L366.092 326.557H363.785V335.903H366.455V329.569C367.085 328.746 368.154 328.896 368.485 329.013V326.557C368.143 326.429 366.893 326.194 366.263 327.347Z"
            fill="#635BFF"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M360.923 324.239L358.316 324.794L358.306 333.35C358.306 334.931 359.491 336.095 361.072 336.095C361.948 336.095 362.589 335.935 362.941 335.742V333.574C362.599 333.713 360.912 334.204 360.912 332.623V328.832H362.941V326.557H360.912L360.923 324.239Z"
            fill="#635BFF"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M353.702 329.27C353.702 328.853 354.044 328.693 354.61 328.693C355.422 328.693 356.447 328.939 357.259 329.377V326.867C356.373 326.514 355.497 326.375 354.61 326.375C352.442 326.375 351 327.507 351 329.398C351 332.346 355.059 331.876 355.059 333.147C355.059 333.638 354.632 333.798 354.033 333.798C353.147 333.798 352.015 333.435 351.117 332.944V335.486C352.111 335.913 353.115 336.095 354.033 336.095C356.255 336.095 357.782 334.995 357.782 333.083C357.772 329.9 353.702 330.466 353.702 329.27Z"
            fill="#635BFF"
        />
        <path
            d="M131.5 393C131.5 388.858 134.858 385.5 139 385.5H163C167.142 385.5 170.5 388.858 170.5 393V417C170.5 421.142 167.142 424.5 163 424.5H139C134.858 424.5 131.5 421.142 131.5 417V393Z"
            fill="var(--et-colors-card-background)"
            stroke="var(--et-colors-border)"
        />
        <path
            d="M157.277 65.6329H149.946C149.318 65.6328 148.711 65.4094 148.233 65.0027C147.755 64.5959 147.437 64.0324 147.337 63.4129L146.074 55.6297C145.973 55.0102 145.656 54.4466 145.178 54.0399C144.7 53.6331 144.093 53.4097 143.465 53.4097H142.741M157.277 65.6329C157.476 65.6244 157.675 65.6564 157.862 65.727C158.049 65.7975 158.219 65.905 158.364 66.0432C158.508 66.1813 158.622 66.3472 158.701 66.5308C158.779 66.7144 158.819 66.9119 158.819 67.1116C158.819 67.3112 158.779 67.5087 158.701 67.6923C158.622 67.876 158.508 68.0418 158.364 68.18C158.219 68.3181 158.049 68.4257 157.862 68.4962C157.675 68.5667 157.476 68.5987 157.277 68.5902C156.895 68.5741 156.535 68.4113 156.271 68.1357C156.007 67.8602 155.859 67.4933 155.859 67.1116C155.859 66.7299 156.007 66.3629 156.271 66.0874C156.535 65.8118 156.895 65.649 157.277 65.6329ZM151 143.763V150.237M154.237 147H147.763M151 238.179H155.531C156.561 238.179 157.549 237.769 158.278 237.041C159.006 236.313 159.415 235.325 159.415 234.295V231.705C159.415 231.195 159.315 230.69 159.12 230.219C158.924 229.748 158.638 229.32 158.278 228.959C157.917 228.598 157.489 228.312 157.018 228.117C156.546 227.922 156.041 227.821 155.531 227.821H154.884M151 238.179C151.486 236.722 152.456 235.751 153.913 235.266M151 238.179C151.486 239.635 152.456 240.606 153.913 241.091M151 227.821H146.469C145.439 227.821 144.451 228.231 143.722 228.959C142.994 229.687 142.585 230.675 142.585 231.705V234.295C142.585 235.325 142.994 236.313 143.722 237.041C144.451 237.769 145.439 238.179 146.469 238.179H147.116M151 227.821C150.515 226.365 149.544 225.394 148.087 224.908M151 227.821C150.515 229.278 149.544 230.249 148.087 230.734M146.375 317.018V315.696C146.375 314.47 146.862 313.293 147.73 312.426C148.597 311.559 149.773 311.071 151 311.071C152.227 311.071 153.403 311.559 154.27 312.426C155.138 313.293 155.625 314.47 155.625 315.696V317.018M148.357 320.481V323.366M153.643 320.481V323.366M157.607 408.634V410.946C157.607 411.297 157.468 411.633 157.22 411.881C156.972 412.129 156.636 412.268 156.286 412.268H143.732C143.382 412.268 143.046 412.129 142.798 411.881C142.55 411.633 142.411 411.297 142.411 410.946V401.696C142.411 399.507 144.186 397.732 146.375 397.732H154.964V401.036M157.607 404.67V402.357C157.607 402.007 157.468 401.671 157.22 401.423C156.972 401.175 156.636 401.036 156.286 401.036H146.375M159.197 56.3816C159.063 57.7999 158.722 59.1908 158.183 60.5097C158.026 60.8901 157.777 61.2253 157.458 61.4851C157.139 61.7449 156.76 61.9211 156.356 61.9976C155.51 62.1628 154.227 62.328 152.487 62.328C151.454 62.3314 150.422 62.2687 149.397 62.1403C147.938 61.9527 146.909 60.7595 146.675 59.3072L145.988 55.0615H157.938C158.667 55.0615 159.266 55.6548 159.197 56.3816ZM148.495 68.5902C148.694 68.5987 148.893 68.5667 149.08 68.4962C149.267 68.4257 149.437 68.3181 149.581 68.18C149.725 68.0418 149.84 67.876 149.918 67.6923C149.997 67.5087 150.037 67.3112 150.037 67.1116C150.037 66.9119 149.997 66.7144 149.918 66.5308C149.84 66.3472 149.725 66.1813 149.581 66.0432C149.437 65.905 149.267 65.7975 149.08 65.727C148.893 65.6564 148.694 65.6244 148.495 65.6329C148.113 65.649 147.753 65.8118 147.489 66.0874C147.225 66.3629 147.077 66.7299 147.077 67.1116C147.077 67.4933 147.225 67.8602 147.489 68.1357C147.753 68.4113 148.113 68.5741 148.495 68.5902ZM151 155.091C156.179 155.091 159.091 152.179 159.091 147C159.091 141.821 156.179 138.908 151 138.908C145.821 138.908 142.908 141.821 142.908 147C142.908 152.179 145.821 155.091 151 155.091ZM143.954 324.686C143.441 322.477 143.204 319.955 143.115 318.339C143.107 318.167 143.133 317.995 143.194 317.834C143.255 317.673 143.348 317.525 143.468 317.402C143.587 317.278 143.731 317.18 143.89 317.114C144.05 317.048 144.221 317.015 144.393 317.018H157.607C158.337 317.018 158.925 317.61 158.885 318.339C158.795 319.954 158.559 322.475 158.046 324.686C157.808 325.71 157.055 326.49 156.014 326.642C154.943 326.796 153.314 326.929 151 326.929C148.686 326.929 147.058 326.796 145.987 326.642C144.945 326.49 144.192 325.71 143.954 324.686ZM158.929 404.67H154.304C153.939 404.67 153.643 404.965 153.643 405.33V407.973C153.643 408.338 153.939 408.634 154.304 408.634H158.929C159.293 408.634 159.589 408.338 159.589 407.973V405.33C159.589 404.965 159.293 404.67 158.929 404.67Z"
            stroke="#344054"
            stroke-width="1.66667"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M521 40H189C184.582 40 181 43.5817 181 48C181 52.4183 184.582 56 189 56H521C525.418 56 529 52.4183 529 48C529 43.5817 525.418 40 521 40Z"
            fill="#8799B5"
            style="opacity: 0.15"
        />
        <path
            d="M480 126H189C184.582 126 181 129.582 181 134C181 138.418 184.582 142 189 142H480C484.418 142 488 138.418 488 134C488 129.582 484.418 126 480 126Z"
            fill="#8799B5"
            style="opacity: 0.15"
        />
        <path
            d="M504 212H189C184.582 212 181 215.582 181 220C181 224.418 184.582 228 189 228H504C508.418 228 512 224.418 512 220C512 215.582 508.418 212 504 212Z"
            fill="#8799B5"
            style="opacity: 0.15"
        />
        <path
            d="M491 298H189C184.582 298 181 301.582 181 306C181 310.418 184.582 314 189 314H491C495.418 314 499 310.418 499 306C499 301.582 495.418 298 491 298Z"
            fill="#8799B5"
            style="opacity: 0.15"
        />
        <path
            d="M448 384H189C184.582 384 181 387.582 181 392C181 396.418 184.582 400 189 400H448C452.418 400 456 396.418 456 392C456 387.582 452.418 384 448 384Z"
            fill="#8799B5"
            style="opacity: 0.15"
        />
        <text
            opacity="0.8"
            fill="var(--et-colors-card-text)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="14"
            letter-spacing="0em"
        >
            <tspan x="181.708" y="421.8">18 hours ago</tspan>
        </text>
        <path d="M273.5 406V426" stroke="#D0D5DD" />
        <text
            opacity="0.8"
            fill="var(--et-colors-card-text)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="14"
            letter-spacing="0em"
        >
            <tspan x="283.874" y="421.8">verified by</tspan>
        </text>
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M394.451 417.267C394.451 414.533 393.127 412.375 390.596 412.375C388.054 412.375 386.516 414.533 386.516 417.246C386.516 420.461 388.331 422.084 390.937 422.084C392.208 422.084 393.17 421.796 393.896 421.39V419.254C393.17 419.617 392.337 419.841 391.279 419.841C390.243 419.841 389.325 419.478 389.207 418.218H394.43C394.43 418.079 394.451 417.523 394.451 417.267ZM389.175 416.252C389.175 415.045 389.912 414.543 390.585 414.543C391.236 414.543 391.931 415.045 391.931 416.252H389.175Z"
            fill="#635BFF"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M382.393 412.375C381.346 412.375 380.673 412.867 380.299 413.208L380.16 412.546H377.81V425L380.481 424.434L380.491 421.411C380.876 421.689 381.442 422.084 382.382 422.084C384.294 422.084 386.035 420.546 386.035 417.16C386.024 414.063 384.262 412.375 382.393 412.375ZM381.752 419.734C381.122 419.734 380.748 419.51 380.491 419.232L380.481 415.27C380.758 414.96 381.143 414.746 381.752 414.746C382.724 414.746 383.397 415.836 383.397 417.235C383.397 418.666 382.734 419.734 381.752 419.734Z"
            fill="#635BFF"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M374.136 411.745L376.817 411.168V409L374.136 409.566V411.745Z"
            fill="#635BFF"
        />
        <path d="M376.817 412.557H374.136V421.902H376.817V412.557Z" fill="#635BFF" />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M371.263 413.347L371.092 412.557H368.785V421.903H371.455V415.569C372.085 414.746 373.154 414.896 373.485 415.013V412.557C373.143 412.429 371.893 412.194 371.263 413.347Z"
            fill="#635BFF"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M365.923 410.239L363.316 410.794L363.306 419.35C363.306 420.931 364.491 422.095 366.072 422.095C366.948 422.095 367.589 421.935 367.941 421.742V419.574C367.599 419.713 365.912 420.204 365.912 418.623V414.832H367.941V412.557H365.912L365.923 410.239Z"
            fill="#635BFF"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M358.702 415.27C358.702 414.853 359.044 414.693 359.61 414.693C360.422 414.693 361.447 414.939 362.259 415.377V412.867C361.373 412.514 360.497 412.375 359.61 412.375C357.442 412.375 356 413.507 356 415.398C356 418.346 360.059 417.876 360.059 419.147C360.059 419.638 359.632 419.798 359.033 419.798C358.147 419.798 357.015 419.435 356.117 418.944V421.486C357.111 421.913 358.115 422.095 359.033 422.095C361.255 422.095 362.782 420.995 362.782 419.083C362.772 415.9 358.702 416.466 358.702 415.27Z"
            fill="#635BFF"
        />
        <rect y="110" width="660" height="356" fill="url(#paint0_linear_3_739)" />
        <defs>
            <linearGradient
                id="paint0_linear_3_739"
                x1="330"
                y1="110"
                x2="330"
                y2="466"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0" stop-color="var(--et-colors-background)" stop-opacity="0" />
                <stop offset="1" stop-color="var(--et-colors-background)" />
            </linearGradient>
        </defs>
    </svg>
</template>
<script setup lang="ts"></script>
